import btnStyle from '@/components/Shares/Button.module.css';
import { ActionIcon, Group } from '@mantine/core';
import { IconLink } from '@tabler/icons-react';
import { Icons } from '../Shares/Icons';
export const BlogSocials: React.FC = () => {
  return <Group gap={10} wrap="nowrap">
      <ActionIcon className={btnStyle.btnIcon} w={40} h={40}>
        <IconLink size={20} />
      </ActionIcon>
      <ActionIcon className={btnStyle.btnIcon} w={40} h={40}>
        <Icons className="icon-pr-flat-x" fontSize={20} />
      </ActionIcon>
      <ActionIcon className={btnStyle.btnIcon} w={40} h={40}>
        <Icons className="icon-pr-flat-instagram" fontSize={20} />
      </ActionIcon>
      <ActionIcon className={btnStyle.btnIcon} w={40} h={40}>
        <Icons className="icon-pr-flat-discord" fontSize={20} />
      </ActionIcon>
      <ActionIcon className={btnStyle.btnIcon} w={40} h={40}>
        <Icons className="icon-pr-flat-facebook" fontSize={20} />
      </ActionIcon>
    </Group>;
};